// import './css/service-edit.css';

import { useState, useEffect } from 'react';
import moment from 'moment';

import DatePicker from 'react-datepicker';

import API from 'service/api';
import Util, { Data, ActionType } from 'service/util';

import Form from 'component/Form';
import ServiceWeekdayPicker from 'component/service/ServiceWeekdayPicker';
import PopMessage from 'component/pop-msg/PopMessage';
import LocationSelect from 'component/dropdown/LocationSelect';
import ModalScreen from 'component/ModalScreen';

const ChangeServiceModal = ({
  vehicle, service, min_dtm,
  closeModal, onUpdatedService,
  ...props
}) =>
{
  // clone service as state
  const ori_dtm = Util.ShortDate(moment(service.start_dtm));
  const ori_company = service.company;

  const [company  , setCompany  ] = useState( service.company       );
  const [srv_dis  , setSrvDis   ] = useState( service.srv_dis       );
  const [srv_loc  , setSrvLoc   ] = useState( service.srv_loc       );
  const [srv_floor, setFloor    ] = useState( service.srv_floor     );
  const [srv_psn  , setPsn      ] = useState( service.srv_psn       );
  const [srv_plan , setPlan     ] = useState( service.srv_plan      );
  const [vh_type  , setVhType   ] = useState( service.vh_type       );
  const [start_dtm, setStartDate] = useState( service.start_dtm     );
  const [weekday1 , setWeekday1 ] = useState( service.weekday1      );
  const [weekday2 , setWeekday2 ] = useState( service.weekday2      );
  const [weekday3 , setWeekday3 ] = useState( service.weekday3      );
  const [waxing   , setWaxing   ] = useState( service.waxing        );
  const [worker   , setWorker   ] = useState( service.worker        );
  const [fee      , setFee      ] = useState( service.fee           );
  const [rotation , setRotation ] = useState( service.rotation      );
  const [extra_fee, setExtraFee ] = useState( service.extra_fee     );

  // dropdown items
  const [_ls_worker, setWorkerList] = useState([]);


  useEffect(() =>
  {
    switch (srv_plan) {
      case 'A':
        setWeekday1(0);
        setWeekday2(0);
        setWeekday3(0);
        setWaxing(true);
        break;
      case 'B':
        setWaxing(true);
        break;
      case 'C':
        setWeekday2(0);
        setWeekday3(0);
        setWaxing(false);
        break;
    }
  }, [srv_plan]);

  useEffect(() => {
    let list = Data.wkrloc[`${srv_dis}${srv_loc}`] || [];
    setWorkerList(list);
    if (!list.some(w => w.uid == worker))
    {
      setWorker(list[0]?.uid || Data.defaultWorkerId);
    }
  }, [srv_dis, srv_loc]);

  const setLocation = (dis, loc, o) =>
  {
    setSrvDis(dis);
    setSrvLoc(loc);
  }

  const setWeekdays = (d1, d2, d3) =>
  {
    setWeekday1(d1);
    setWeekday2(d2);
    setWeekday3(d3);
  }

  const submit = e=>
  {
    e.preventDefault();
    e.stopPropagation();

    let dto = {...service, action: ActionType.Change, ori_dtm, ori_company,
      company, start_dtm,
      srv_dis, srv_loc, srv_floor, srv_psn,
      srv_plan, vh_type, worker,
      weekday1, weekday2, weekday3,
      waxing, rotation, fee, extra_fee,
    };

    dto.ori_dtm   = Util.ShortDate(dto.ori_dtm);
    dto.start_dtm = Util.ShortDate(dto.start_dtm);
    dto.end_dtm   = Util.ShortDate(dto.end_dtm)||null;

    API.changeServiceRecord(dto).then(resp =>
    {
      if (resp.success) {
        // copy
        Object.assign(service, dto);
        PopMessage.show('已成功修改記錄。', '成功', 'success');
        onUpdatedService(resp.msg);
        closeModal();
      } else {
        PopMessage.show(resp.msg, '失敗', 'danger');
      }
    });

    return false;
  }

  return (
    <ModalScreen className="sem sem-change" show={true}
      title={`修改車輛服務 - ${vehicle.cd_license}`}
      onClose={closeModal}>
      <Form onSubmit={submit}>
        <p className="message white">
          預定未來的服務變更，此動作將為所選取的資料列設下完結日期，並產生將會在未來生效的新資料列。
        </p>

        <label className="field">
          <strong>服務開始日</strong>
          <DatePicker selected={start_dtm} onChange={d=>setStartDate(d)}
                      dateFormat="yyyy-MM-dd" minDate={min_dtm} />
        </label>

        <div className="split-3">
          <label className="field">
            <strong>公司</strong>
            <select value={company} onChange={e=>setCompany(e.target.value)}>
              { Data.company.map(com =>
                <option key={com.cd} value={com.cd}>{com.cd} - {com.name}</option>
              )}
            </select>
          </label>
          <label className="field">
            <strong>計劃</strong>
            <select value={srv_plan} onChange={e=>setPlan(e.target.value)}>
              { Data.plan.map(p =>
                <option key={`plan-${p}`} value={p}>{ p }</option>
              )}
            </select>
          </label>
          <label className="field">
            <strong>服務日</strong>
            <ServiceWeekdayPicker plan={srv_plan}
              d1={weekday1} d2={weekday2} d3={weekday3}
              onChange={setWeekdays} />
          </label>
        </div>

        <div className="split-3">
          <LocationSelect labelClass="field"
            district={srv_dis}
            location={srv_loc}
            onUpdate={setLocation}
          />
        </div>
        <div className="split-3">
          <label className="field">
            <strong>車種</strong>
            <select className="nc-vhtype" value={vh_type}
                    onChange={e=>setVhType(parseInt(e.target.value, 10))}>
              { Data.vtype.map(t =>
                <option key={`vt-${t.id}`} value={t.id}>{t.id} - {t.desc}</option>
              )}
            </select>
          </label>
          <label className="field">
            <strong>打蠟</strong>
            <input type="checkbox" checked={waxing}
                  onChange={e=>setWaxing(e.target.checked)} />
          </label>
        </div>
        <label className="field">
          <strong>樓層</strong>
          <input type="text" placeholder="車輛停泊樓層" value={srv_floor}
                  onChange={e=>setFloor(e.target.value)} />
        </label>
        <label className="field">
          <strong>車位</strong>
          <input type="text" placeholder="車位號碼" value={srv_psn}
                  onChange={e=>setPsn(e.target.value)} />
        </label>
        <div className="split-3">
          <label className="field">
            <strong>月費</strong>
            <input type="number" placeholder="價錢" value={fee} required
                    onChange={e=>setFee( parseFloat(e.target.value) )} />
          </label>
          <label className="field">
            <strong>附加項目</strong>
            <input type="text" placeholder="如輪抹車" value={rotation}
                    onChange={e=>setRotation( e.target.value )} />
          </label>
          <label className="field">
            <strong>附加費</strong>
            <input type="number" placeholder="每月固定收費" value={extra_fee} required
                    onChange={e=>setExtraFee(  parseFloat(e.target.value) )} />
          </label>
        </div>
        <label className="field">
          <strong>負責工人</strong>
          <select value={worker} required
                  onChange={e=>setWorker( parseInt(e.target.value, 10) )}>
            <option value={Data.defaultWorkerId}>{Data.defaultWorkerId} - 公司預設</option>
            { _ls_worker.map(w =>
              <option key={`wkr-${w.uid}`} value={w.uid}>{w.uid} - {w.name}</option>
            )}
            <option value={worker}>{worker} - 當前工人</option>
          </select>
        </label>
        <div className="action-panel">
          <button className="btn grey" type="button"
                  onClick={e=>closeModal()}>關閉</button>
          <button id="btn-submit" className="btn blue" >確定</button>
        </div>
      </Form>
    </ModalScreen>
  );

}


export default ChangeServiceModal;
